// ...existing code...
export const faq = [
    {
        question: "What is recipe generation and how does it work?",
        answer: "Recipe generation uses your selected parameters (ingredients, cuisine, dietary preferences, cook time, etc.) to create a complete recipe including name, ingredients list, quantities, and step-by-step procedure. Generated recipes are produced by our generation service and can be saved or shared.",
    },
    {
        question: "Can I edit a generated recipe before saving?",
        answer: "No. Generated recipes are not editable. If you want to edit the recipe, you will need to save it first to your library.",
    },
    {
        question: "How do I save a recipe to my account?",
        answer: "Use the Save button on the generation recipe page. Saving requires being signed in; saved recipes will appear in your Library and can be edited or deleted later.",
    },
    {
        question: "What’s the difference between a saved Recipe and a Generation?",
        answer: "A Generation is a temporary output produced by the generator (it may be anonymous). A saved Recipe is stored in your account as a first-class resource with ownership, comments, and full metadata.",
    },
    {
        question: "How does sharing a recipe work?",
        answer: "You can share either a full recipe URL (public page) or a short quickview link backed by a code. Quickview links point to an entry that loads the recipe or generation data without exposing internal IDs while bypassing visibility settings for sharing with non coocoo users.",
    },
    {
        question: "Are shared recipe links permanent?",
        answer: "Yes, both types of links (full recipe URL or short quickview) are both permanent.",
    },
    {
        question: "Can I control recipe visibility?",
        answer: "Yes. When creating or editing a recipe you can set visibility to public, private, or personal. Public recipes are discoverable by anyone on the site, private recipes are only accessible by you and those that you've accepted as followers, and personal recipes are only accessible by you.",
    },
    {
        question: "What if an ingredient is missing from the autocomplete?",
        answer: "Use the 'Missing Ingredient?' option in the ingredients autocomplete to open the modal and add a custom ingredient. Our team will review all of the ingredients suggested by the community and add them to the list!",
    },
    {
        question: "How accurate are generated ingredient quantities and cook times?",
        answer: "Generated quantities and cook times are estimates intended as a starting point. Please review and adjust measurements and timings to suit your equipment and taste.",
    },
    {
        question: "Can I include images with my recipes?",
        answer: "Yes. You can attach images to a saved recipe. This image will show as the thumbnail for the recipe and also the cover photo whenever viewing the recipe's page.",
    },
    {
        question: "How is my data used — do you store my prompts or generated content?",
        answer: "We store generation details, including prompts and generated content, for 30 days if you're a logged in user. This data is stored to ensure that our generation system can curate the best recipes for your tastebuds.",
    },
    {
        question: "If I want to contact the CooCoo team, what do I do?",
        answer: "You can reach us with the Contact page accessible from the menus on the top left. Please contact us about any bugs, improvements, questions, or just to say hi!",
    },
    {
        question: "All of my posts and recipes are set to Private by default! Is there a way to change this?",
        answer: "There is! If you go to your account settings through the top right avatar, you can change the default visibility for your posts and recipes.",
    },
];
